<template>
  <div class="content">
    <div class="title">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
          <el-menu-item  @click="switchCollapse"  style="width: 44px">
            <img src="@/assets/logo.png" alt="" style="width: 25px; height: 25px;">
          </el-menu-item>
          <el-menu-item>
            <span style="font-weight: 600; color: #409EFF;font-size: 22px">应用中心</span>
          </el-menu-item>
          <el-menu-item v-if="userData.isAdmin">
            <div class="menu-line"></div>
            <el-button @click="switchMode" type="text">前往设计</el-button>
          </el-menu-item>
          <el-menu-item>
            <div class="menu-line"></div> 
            <el-input placeholder="搜索菜单" v-model="searchMenuVal" @clear="clearFilterMenu"  clearable class="input-with-select">
              <el-button @click="filterMenu()" slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </el-menu-item>
          <el-menu-item v-if="sysInfoModel.name">
            <div class="menu-line"></div>
            <el-tooltip
              placement="bottom"
              effect="dark"
              :disabled="!hospitalTooltipContent">
              <template slot="content">
                <div v-html="hospitalTooltipContent"></div>
              </template>
              <span class="inst-name">{{sysInfoModel.name}}</span>
            </el-tooltip>
            <el-tooltip
              :content="lastScheduleSyncTimeText"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                type="primary"
                plain
                size="mini"
                icon="el-icon-refresh"
                :loading="hdisScheduleSyncing"
                style="margin-left: 16px;"
                @click.stop="syncHdisSchedule"
              >同步排班</el-button>
            </el-tooltip>
          </el-menu-item> 
          <el-menu-item style="padding: 0 8px;">
            <el-button 
              size="mini"
              icon="el-icon-s-order"
              @click.stop="showWorkOrderList"
            >工单</el-button>
          </el-menu-item>
          <el-submenu class="user" index="2">
            <template slot="title">{{userData.name ?? "未知"}}</template>
            <el-menu-item @click="showUserInfo" index="2-1">我的资料</el-menu-item>
            <el-menu-item @click="logout" index="2-3">退出登录</el-menu-item>
          </el-submenu>
      </el-menu>
    </div>
    <div class="body">
      <!-- 应用菜单 -->
      <div class="menu"> 
        <el-skeleton class="skeleton" v-if="loading" :rows="16" animated /> 
        <el-menu
          v-if="!loading"
          :default-active="menuActiveIndex"
          :default-openeds="defaultOpeneds"
          :collapse="isCollapse"
          class="el-menu-vertical-demo">
          <div v-for="(menu, index) in menuList" :key="index">
            <!-- 有流程的 -->
            <el-submenu :index="menu.id" v-if="menu.mode == 0 && menu.type == 1">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span v-if="!isCollapse">{{menu.name}}</span>
              </template>
              <el-menu-item-group v-for="(smenu, sindex) in menu.items" :key="sindex" >
                <template slot="title">{{ smenu.name }}</template>
                <div class="menu-null" v-if="!smenu.items || smenu.items.length < 1">该流程暂无表单</div>
                <el-menu-item @click="jumpApp(ssmenu, index, ssindex)" v-for="(ssmenu, ssindex) in smenu.items" :key="ssindex" 
                  :index="ssmenu.id"><span :style="isEmptyRoute(ssmenu) ? {color: 'red'} : {}">{{ ssmenu.name }}</span></el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- 无流程的 -->
            <el-submenu :index="menu.id" v-if="menu.mode == 1 && menu.type == 1">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span v-if="!isCollapse">{{menu.name}}</span>
              </template>
              <div class="menu-null" v-if="!menu.items || menu.items.length < 1">该应用暂无表单</div>
              <el-menu-item @click="jumpApp(ssmenu, index, ssindex)" v-for="(ssmenu, ssindex) in menu.items" :key="ssindex" 
                  :index="ssmenu.id || (`${index}` + '-' + `${ssindex}`)">
                  <span v-if="ssmenu.type != 20" :style="isEmptyRoute(ssmenu) ? {color: 'red'} : {}">{{ ssmenu.name }}</span>
                  <span v-if="ssmenu.type == 20 && ssmenu.dumpMode != 1" :style="isEmptyRoute(ssmenu) ? {color: 'red'} : {}">{{ ssmenu.name }}</span>
                  <!-- 跳转链接的菜单 -->
                  <span v-if="ssmenu.type == 20 && ssmenu.dumpMode == 1" :style="isEmptyRoute(ssmenu) ? {color: 'red'} : {}">{{ ssmenu.name }}</span>
                </el-menu-item>
            </el-submenu> 
            <!-- 报表 -->
            <el-menu-item v-if="menu.type == 10" @click="jumpApp(menu, index, null)" :index="menu.id">
                <template slot="title">
                  <i class="el-icon-tickets"></i>
                  <span :style="isEmptyRoute(menu) ? {color: 'red'} : {}">{{ menu.name }}</span>
                </template>
            </el-menu-item>
            <el-submenu :index="menu.id" v-if="menu.type == 11">
              <template slot="title">
                <i class="el-icon-s-data"></i>
                <span v-if="!isCollapse">{{menu.name}}</span>
              </template>
              <div class="menu-null" v-if="!menu.items || menu.items.length < 1">该类别暂无报表</div>
              <div v-if="menu.type == 10">
                <el-menu-item @click="jumpApp(menu, index, null)" :index="menu.id">
                    <template slot="title">
                      <i class="el-icon-tickets"></i>
                      {{ menu.name }}
                    </template>
                </el-menu-item>
              </div> 
              <div v-if="menu.type == 11 && menu.items && menu.items.length > 0">
                <div v-for="(ssmenu, ssindex) in menu.items" :key="ssindex">
                  <div v-if="ssmenu.type == 10">
                      <el-menu-item @click="jumpApp(ssmenu, index, ssindex)" :index="ssmenu.id">
                          <template slot="title">
                            <i class="el-icon-tickets"></i>
                            <span :style="isEmptyRoute(ssmenu) ? {color: 'red'} : {}">{{ ssmenu.name }}</span>
                          </template>
                      </el-menu-item>
                  </div> 
                  <div v-if="ssmenu.type == 11">
                    <el-submenu :key="ssindex" :index="ssmenu.id">
                        <template slot="title"> <i class="el-icon-s-data"></i>{{ ssmenu.name }}</template>
                        <div v-if="ssmenu.type == 11" >
                          <el-menu-item
                            @click="jumpApp(sssmenu, index, ssindex)"
                            v-for="(sssmenu, sssindex) in ssmenu.items"  :key="sssindex" 
                            :index="sssmenu.id || (`${index}` + '-' + `${ssindex}`+ `${sssindex}`)">
                            <i class="el-icon-tickets"></i><span :style="isEmptyRoute(sssmenu) ? {color: 'red'} : {}">{{ sssmenu.name }}</span>
                          </el-menu-item>
                          <div class="menu-null" v-if="!ssmenu.items || ssmenu.items.length < 1">该类别暂无报表</div>
                        </div>
                    </el-submenu>
                  </div>
                </div>
                <div class="menu-null" v-if="!menu.items || menu.items.length < 1">该类别暂无报表</div>
              </div>
            </el-submenu>
          </div>
          <el-empty :image-size="25" class="empty" v-if="loading == false && menuList.length < 1" description="暂无菜单"></el-empty>
        </el-menu>
      </div>
      <div class="main">
        <router-view v-if="!currExtData && !routeLoading" :key="$route.fullPath" /> 
        <el-skeleton class="skeleton" v-if="extloading || routeLoading" :rows="16" animated />
        <iframe v-if="currExtData" class="ext" :src="currExtData.path" frameborder="0"></iframe>
      </div>
    </div>
    <el-dialog  
        title="用户资料"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        :visible.sync="userInfoVisible">
        <div>
            <user-info />
        </div>
    </el-dialog>
    <el-dialog  
        title="Ai问答"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="1200px"
        :visible.sync="aiVisbile">
        <div>
            <ai-chat />
        </div>
    </el-dialog>
    <!-- 发起工单弹框 -->
    <!-- 工单列表弹框 -->
    <el-dialog title="工单" :visible.sync="workOrderListVisible" width="900px" :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
        <div>
          <el-radio-group v-model="workOrderListFilter" size="small" @change="loadWorkOrderList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="0">待处理</el-radio-button>
            <el-radio-button label="1">处理中</el-radio-button>
            <el-radio-button label="3">已关闭</el-radio-button>
          </el-radio-group>
        </div>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="showWorkOrderForm">发起工单</el-button>
      </div>
      <el-table :data="workOrderListData" v-loading="workOrderListLoading" stripe border size="small" @row-click="viewWorkOrderDetail">
        <el-table-column label="标题" prop="title" min-width="200" show-overflow-tooltip />
        <el-table-column label="提交人" prop="creatorUserName" width="100" />
        <el-table-column label="标签" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.tag === 0" type="danger" size="mini">系统Bug</el-tag>
            <el-tag v-else-if="row.tag === 1" type="warning" size="mini">功能建议</el-tag>
            <el-tag v-else-if="row.tag === 2" size="mini">使用咨询</el-tag>
            <el-tag v-else type="info" size="mini">其他</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status === 0" type="warning" size="mini">待处理</el-tag>
            <el-tag v-else-if="row.status === 1" type="" size="mini">处理中</el-tag>
            <el-tag v-else-if="row.status === 2" type="success" size="mini">已处理</el-tag>
            <el-tag v-else-if="row.status === 3" type="info" size="mini">已关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" width="150">
          <template slot-scope="{ row }">{{ formatDateTime(row.creationTime) }}</template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 12px; padding-bottom: 10px; text-align: right;">
        <el-pagination layout="total, prev, pager, next" :total="workOrderListTotal" :page-size="10" :current-page.sync="workOrderListPage" @current-change="loadWorkOrderList" />
      </div>
    </el-dialog>
    <!-- 工单详情弹框 -->
    <el-dialog :title="'工单详情 - ' + (workOrderDetail.title || '')" :visible.sync="workOrderDetailVisible" width="750px" :close-on-click-modal="false" append-to-body>
      <div v-loading="workOrderDetailLoading" style="padding-bottom: 10px;">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="提交人">{{ workOrderDetail.creatorUserName }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag v-if="workOrderDetail.status === 0" type="warning" size="mini">待处理</el-tag>
            <el-tag v-else-if="workOrderDetail.status === 1" size="mini">处理中</el-tag>
            <el-tag v-else-if="workOrderDetail.status === 2" type="success" size="mini">已处理</el-tag>
            <el-tag v-else-if="workOrderDetail.status === 3" type="info" size="mini">已关闭</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="标签">
            <el-tag v-if="workOrderDetail.tag === 0" type="danger" size="mini">系统Bug</el-tag>
            <el-tag v-else-if="workOrderDetail.tag === 1" type="warning" size="mini">功能建议</el-tag>
            <el-tag v-else-if="workOrderDetail.tag === 2" size="mini">使用咨询</el-tag>
            <el-tag v-else type="info" size="mini">其他</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="提交时间">{{ formatDateTime(workOrderDetail.creationTime) }}</el-descriptions-item>
          <el-descriptions-item label="工单内容" :span="2">
            <div v-html="workOrderDetail.content" style="line-height: 1.6;" />
          </el-descriptions-item>
          <el-descriptions-item v-if="workOrderDetail.remark" label="备注" :span="2">{{ workOrderDetail.remark }}</el-descriptions-item>
          <el-descriptions-item v-if="workOrderDetail.traceId" label="TraceId" :span="2">
            <code>{{ workOrderDetail.traceId }}</code>
          </el-descriptions-item>
          <el-descriptions-item v-if="workOrderDetail.resolution" label="处理方案" :span="2">{{ workOrderDetail.resolution }}</el-descriptions-item>
          <el-descriptions-item v-if="workOrderDetail.claimedByUserName" label="认领人">{{ workOrderDetail.claimedByUserName }}</el-descriptions-item>
          <el-descriptions-item v-if="workOrderDetail.claimedTime" label="认领时间">{{ formatDateTime(workOrderDetail.claimedTime) }}</el-descriptions-item>
          <el-descriptions-item v-if="workOrderDetail.resolvedByUserName" label="处理人">{{ workOrderDetail.resolvedByUserName }}</el-descriptions-item>
          <el-descriptions-item v-if="workOrderDetail.resolvedTime" label="处理时间">{{ formatDateTime(workOrderDetail.resolvedTime) }}</el-descriptions-item>
        </el-descriptions>
        <div v-if="(workOrderDetail.images && workOrderDetail.images.length) || workOrderDetail.screenshotUrl" style="margin-top: 12px;">
          <div style="font-weight: bold; margin-bottom: 8px;">截图</div>
          <div style="display: flex; flex-wrap: wrap; gap: 8px;">
            <el-image v-for="img in (workOrderDetail.images || [])" :key="img.id" :src="img.imageUrl" :preview-src-list="(workOrderDetail.images || []).map(i => i.imageUrl)" style="width: 150px; height: 120px; border: 1px solid #ebeef5; border-radius: 4px; object-fit: cover;" fit="cover" />
            <el-image v-if="workOrderDetail.screenshotUrl && !(workOrderDetail.images && workOrderDetail.images.length)" :src="getFullUrl(workOrderDetail.screenshotUrl)" :preview-src-list="[getFullUrl(workOrderDetail.screenshotUrl)]" style="width: 150px; height: 120px; border: 1px solid #ebeef5; border-radius: 4px;" fit="cover" />
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="发起工单"
        :close-on-click-modal="false"
        width="700px"
        :visible.sync="workOrderFormVisible"
        @close="resetWorkOrderForm">
        <el-form ref="workOrderForm" :model="workOrderForm" :rules="workOrderRules" label-width="100px">
          <el-form-item label="工单标题" prop="title">
            <el-input v-model="workOrderForm.title" placeholder="请输入工单标题" maxlength="200" show-word-limit />
          </el-form-item>
          <el-form-item label="工单标签" prop="tag">
            <el-radio-group v-model="workOrderForm.tag">
              <el-radio-button :label="0">系统Bug</el-radio-button>
              <el-radio-button :label="1">数据异常</el-radio-button>
              <el-radio-button :label="2">功能缺失</el-radio-button>
              <el-radio-button :label="3">用户操作不当</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="工单内容" prop="content">
            <el-input v-model="workOrderForm.content" type="textarea" :rows="5" placeholder="请描述问题详情" />
          </el-form-item>
          <el-form-item label="截图（最多5张）">
            <el-upload
              action=""
              :http-request="handleImageUpload"
              list-type="picture-card"
              accept=".jpg,.jpeg,.png,.gif,.webp"
              :before-upload="beforeScreenshotUpload"
              :file-list="workOrderForm.imageFileList"
              :on-remove="handleImageRemove"
              :limit="5"
              :on-exceed="() => $message.warning('最多上传5张截图')"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="workOrderForm.remark" type="textarea" :rows="2" placeholder="选填" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="workOrderFormVisible = false">取消</el-button>
          <el-button type="primary" :loading="workOrderSubmitting" @click="submitWorkOrder">提交</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script> 
import UserInfo from '@/components/users/UserInfo.vue';

import AiChat from './dialogs/AiChatDialog.vue';
import { clearCache, getLocalUser } from '@/services/user.service';
import { getMenu } from '@/services/app.service'; 
import { getHospital } from '@/services/inst.service';
import { hdisListPatients } from '@/services/his.hdis';
import { hisSyncFromHdis, hisGetLatestScheduleSyncTime } from '@/services/his.patient';
import authrequest from '@/utils/authrequest';
import dayjs from 'dayjs';
export default {
  name: 'AppView',
  components: {
    UserInfo,
    AiChat
  },
  created(){
      this.userData = getLocalUser();
  },
  data() {
    return {
      sysInfoModel: {name: ''},
      hospitalInfo: null,
      userInfoVisible: false,
      aiVisbile: false,
      activeIndex: '',
      menuActiveIndex: '',
      defaultOpeneds: [],
      isCollapse: false,
      extloading: false,
      loading: false,
      routeLoading: false,
      menuList: [],
      allMenuList: [],
      currExtData: undefined,
      searchMenuVal: '',
      menuPathMap: {}, // 存储路径到菜单索引的映射
      hdisScheduleSyncing: false,
      lastScheduleSyncTime: null,
      isNavigating: false,
      pendingJumpAppId: null, // 防止同一菜单项重复触发 jumpApp
      navSeqId: 0, // 导航序列号，用于解决快速连续点击菜单的竞态问题
      // 工单表单
      workOrderFormVisible: false,
      workOrderSubmitting: false,
      screenshotUploading: false,
      workOrderId: '',
      // 工单列表
      workOrderListVisible: false,
      workOrderListLoading: false,
      workOrderListData: [],
      workOrderListTotal: 0,
      workOrderListPage: 1,
      workOrderListFilter: '',
      // 工单详情
      workOrderDetailVisible: false,
      workOrderDetailLoading: false,
      workOrderDetail: {},
      // 工单表单
      workOrderForm: {
        title: '',
        tag: 0,
        content: '',
        remark: '',
        imageUrls: [],
        imageFileList: []
      },
      workOrderRules: {
        title: [{ required: true, message: '请输入工单标题', trigger: 'blur' }],
        tag: [{ required: true, message: '请选择工单标签', trigger: 'change' }],
        content: [{ required: true, message: '请输入工单内容', trigger: 'blur' }]
      }
    };
  },
  watch: {
    '$route': {
      handler(to, from) {
        if (this.isNavigating) {
          return;
        }
        
        // 路由变化时，如果之前是扩展应用，清空扩展数据
        if (this.currExtData) {
          this.currExtData = undefined;
        }
        
        // 路由变化时立即隐藏旧内容，显示加载占位
        if (from && from.path !== to.path) {
          this.routeLoading = true;
          // 使用 nextTick 确保在下一个渲染周期显示加载占位
          this.$nextTick(() => {
            // 等待路由组件异步加载和挂载完成
            // 使用 setTimeout 确保有足够时间让路由组件加载
            setTimeout(() => {
              this.routeLoading = false;
              // 路由变化时更新菜单状态
              if (this.menuList && this.menuList.length > 0) {
                this.updateMenuState();
              }
            }, 100);
          });
        } else {
          // 路由变化时更新菜单状态
          if (this.menuList && this.menuList.length > 0) {
            this.updateMenuState();
          }
        }
      },
      immediate: false
    }
  },
  mounted(){
      this.getAppMenu(); 
      this.loadHospitalInfo();
      this.loadLastScheduleSyncTime();
  },
  computed: {
    hospitalTooltipContent() {
      if (!this.hospitalInfo) {
        return '';
      }
      const info = this.hospitalInfo;
      const hasInsurance = info.admvs || info.Admvs || info.Admdvs;
      return hasInsurance ? '' : '无医保模式';
    },
    lastScheduleSyncTimeText() {
      if (!this.lastScheduleSyncTime) {
        return '尚未同步过排班信息';
      }
      return '最后同步时间：' + dayjs(this.lastScheduleSyncTime).format('YYYY-MM-DD HH:mm:ss');
    },
    
  },
  methods: {
    loadHospitalInfo(){
      const res = getHospital();
      this.hospitalInfo = res || null;
      this.sysInfoModel.name = res ? res.name : '';
    },
    /** 一键同步所有 HDIS 患者排班信息 */
    async syncHdisSchedule() {
      this.hdisScheduleSyncing = true;
      try {
        let allPatients = [];
        let pageIndex = 1;
        const pageSize = 200;
        let hasMore = true;
        while (hasMore) {
          const res = await hdisListPatients({ pageIndex, pageSize });
          const items = Array.isArray(res) ? res : [];
          allPatients = allPatients.concat(items);
          hasMore = items.length >= pageSize;
          pageIndex++;
        }
        if (allPatients.length === 0) {
          this.$message.warning('HDIS 无患者数据');
          return;
        }
        const syncItems = allPatients.map(row => ({
          hdisPatientId: row.id || '',
          patientName: row.patientName || '',
          patientSex: row.patientSex || '',
          patientBirthday: row.patientBirthday || null,
          cardNum: row.cardNum || '',
          dialysisId: row.dialysisId || '',
          contactPhone: row.contactPhone || '',
          mailingAddress: row.mailingAddress || '',
          scheduleClassName: row.scheduleClassName || '',
          scheduleClassTime: row.scheduleClassTime || '',
          treatmentMode: row.treatmentMode || '',
          areaName: row.areaName || ''
        }));
        const result = await hisSyncFromHdis({ items: syncItems });
        this.$message.success(`排班同步完成：新增 ${result.createdCount || 0} 人，更新 ${result.updatedCount || 0} 人`);
        this.loadLastScheduleSyncTime();
      } catch (e) {
        console.error('同步排班失败:', e);
        this.$message.error('同步排班失败');
      } finally {
        this.hdisScheduleSyncing = false;
      }
    },
    /** 获取最晚的排班同步时间 */
    async loadLastScheduleSyncTime() {
      try {
        const res = await hisGetLatestScheduleSyncTime();
        this.lastScheduleSyncTime = res || null;
      } catch (e) {
        // 静默失败，不影响主流程
      }
    },
    showAiChat(){
      this.aiVisbile = true;
    }, 
    async getAppMenu(){
      this.loading = true;
      try {
        const res = await getMenu();
        this.allMenuList = JSON.stringify(res);
        this.menuList = res; 
        
        if (this.$route.params.id) { 
            let index = this.menuList.findIndex(c=> c.id == this.$route.params.id);
            if (index > -1) {
              this.menuActiveIndex = this.menuList[index].id;
              if (this.menuList[index].items && this.menuList[index].items.length > 0) {
                // 检查第一个子项是否已经是当前路由，避免重复跳转
                const firstItem = this.menuList[index].items[0];
                const expectedPath = this.getExpectedPath(firstItem);
                // 如果 expectedPath 为 null（扩展应用数据不存在），或者路径不匹配，才跳转
                if (expectedPath && this.$route.path !== expectedPath && !this.isNavigating) {
                  this.jumpApp(firstItem, index, 0);
                } else {
                  await this.updateMenuState();
                }
              }
            }
        } else {
          // 如果没有params.id，根据当前路由路径匹配菜单
          await this.updateMenuState();
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    // 根据菜单项获取预期的路由路径
    getExpectedPath(item) {
      if (!item) return null;
      if (item.type == 10) {
        return '/index/report/' + item.id;
      } else if (item.type == 20) {
        return item.path;
      } else {
        // 普通应用：优先使用 code 或 path
        if (item.code) {
          return '/index/' + item.code;
        } else if (item.path) {
          return item.path;
        } else {
          return '/index/app/' + item.id;
        }
      }
    },
    // 根据菜单项获取其在 el-menu 中的 index 值（与模板 :index 一致）
    getMenuItemIndex(item, menuIndex, itemIndex) {
      if (item && item.id) return item.id;
      if (menuIndex !== null && menuIndex !== undefined && itemIndex !== null && itemIndex !== undefined) {
        return `${menuIndex}-${itemIndex}`;
      }
      return '';
    },
    // 根据当前路由路径更新菜单状态
    async updateMenuState() {
      if (!this.menuList || this.menuList.length === 0) {
        return;
      }
      
      if (this.isNavigating) {
        return;
      }
      const currentPath = this.$route.path;
      
      // 首先检查路径映射缓存
      if (this.menuPathMap[currentPath]) {
        const { menuIndex, itemIndex, itemId } = this.menuPathMap[currentPath];
        const menu = this.menuList[menuIndex];
        if (menu) {
          // 优先用 itemId（与模板 :index 一致），fallback 到 index 拼接
          if (itemId) {
            this.menuActiveIndex = itemId;
          } else if (itemIndex !== null && itemIndex !== undefined) {
            this.menuActiveIndex = `${menuIndex}-${itemIndex}`;
          } else {
            this.menuActiveIndex = menu.id;
          }
          this.defaultOpeneds = [menu.id];
          return;
        }
      }
      
      // 遍历菜单列表查找匹配的菜单项（含有流程菜单的二级子项）
      for (let menuIndex = 0; menuIndex < this.menuList.length; menuIndex++) {
        const menu = this.menuList[menuIndex];
        
        // 检查菜单项的子项
        if (menu.items && menu.items.length > 0) {
          // 有流程菜单(mode==0)：items 是流程组，每个流程组下有 items 才是叶子菜单
          if (menu.mode == 0 && menu.type == 1) {
            for (let gIndex = 0; gIndex < menu.items.length; gIndex++) {
              const group = menu.items[gIndex];
              if (group.items && group.items.length > 0) {
                for (let iIndex = 0; iIndex < group.items.length; iIndex++) {
                  const item = group.items[iIndex];
                  const itemPath = this.getMenuItemRoute(item);
                  if (itemPath && itemPath === currentPath) {
                    this.menuActiveIndex = item.id || `${menuIndex}-${gIndex}-${iIndex}`;
                    this.defaultOpeneds = [menu.id];
                    this.menuPathMap[currentPath] = { menuIndex, itemIndex: iIndex, itemId: item.id, menuId: menu.id };
                    return;
                  }
                }
              }
            }
            continue;
          }
          
          for (let itemIndex = 0; itemIndex < menu.items.length; itemIndex++) {
            const item = menu.items[itemIndex];
            const itemPath = this.getMenuItemRoute(item);
            
            if (itemPath && itemPath === currentPath) {
              this.menuActiveIndex = this.getMenuItemIndex(item, menuIndex, itemIndex);
              this.defaultOpeneds = [menu.id];
              this.menuPathMap[currentPath] = { menuIndex, itemIndex, itemId: item.id, menuId: menu.id };
              return;
            }
            
            // 如果是扩展应用类型(type == 20)，从缓存中获取其路径
            if (item.type == 20) {
              const extData = this.extDataCache ? this.extDataCache[item.id] : null;
              if (extData && extData.path) {
                this.menuPathMap[extData.path] = { menuIndex, itemIndex, itemId: item.id, menuId: menu.id };
                
                if (extData.path === currentPath) {
                  this.menuActiveIndex = this.getMenuItemIndex(item, menuIndex, itemIndex);
                  this.defaultOpeneds = [menu.id];
                  return;
                }
              }  
            } else {
              // 处理普通路由（非扩展应用）
              const routeName = currentPath.split('/').pop();
              if (routeName && routeName !== 'index') {
                const expectedPath = `/index/${routeName}`;
                if (currentPath === expectedPath) {
                  const itemRouteName = item.code || item.path?.split('/').pop() || item.id;
                  if (itemRouteName === routeName || 
                      item.code === routeName || 
                      item.id === routeName ||
                      (item.path && item.path === currentPath)) {
                    this.menuActiveIndex = this.getMenuItemIndex(item, menuIndex, itemIndex);
                    this.defaultOpeneds = [menu.id];
                    this.menuPathMap[currentPath] = { menuIndex, itemIndex, itemId: item.id, menuId: menu.id };
                    return;
                  }
                }
              }
            }
            
            // 报表子分类(type==11)的叶子节点
            if (item.type == 11 && item.items && item.items.length > 0) {
              for (let subIndex = 0; subIndex < item.items.length; subIndex++) {
                const subItem = item.items[subIndex];
                const subPath = this.getMenuItemRoute(subItem);
                if (subPath && subPath === currentPath) {
                  this.menuActiveIndex = this.getMenuItemIndex(subItem, menuIndex, subIndex);
                  this.defaultOpeneds = [menu.id, item.id];
                  this.menuPathMap[currentPath] = { menuIndex, itemIndex: subIndex, itemId: subItem.id, menuId: menu.id };
                  return;
                }
              }
            }
          }
        }
      }
      
      // 如果没有找到匹配的菜单项，尝试匹配路由名称（仅扩展应用）
      const routeName = currentPath.split('/').pop();
      if (routeName && routeName !== 'index') {
        for (let menuIndex = 0; menuIndex < this.menuList.length; menuIndex++) {
          const menu = this.menuList[menuIndex];
          if (menu.items && menu.items.length > 0) {
            for (let itemIndex = 0; itemIndex < menu.items.length; itemIndex++) {
              const item = menu.items[itemIndex];
              if (item.type == 20) {
                const extData = this.extDataCache ? this.extDataCache[item.id] : null;
                if (extData && extData.path) {
                  this.menuPathMap[extData.path] = { menuIndex, itemIndex, itemId: item.id, menuId: menu.id };
                  
                  if (extData.path.includes(routeName) || extData.path.endsWith('/' + routeName)) {
                    this.menuActiveIndex = this.getMenuItemIndex(item, menuIndex, itemIndex);
                    this.defaultOpeneds = [menu.id];
                    return;
                  }
                }
              }
            }
          }
        }
      }
    },
    clearFilterMenu(){
      this.menuList = JSON.parse(this.allMenuList);
    },
    filterMenu(){
      this.searchMenuVal = this.searchMenuVal.trim();
      if (!this.searchMenuVal){
        this.menuList = JSON.parse(this.allMenuList);
        return;
      }
      let rmList = [];
      this.menuList.forEach((c, index)=>{
        let rm = true;
        if (c.items && c.items.length > 0) {
          c.items.forEach((cc, indexx)=>{
            if (cc.name.indexOf(this.searchMenuVal) == -1) {
              rmList.push(index + ","+ indexx);
            } else {
              rm = false;
            }
          })
        }
        if(rm){
          if (c.name.indexOf(this.searchMenuVal) == -1) {
            rmList.push(index);
          } 
        } 
      })
      // 逆序排序，确保先删除子项，再删除父项
      rmList.sort((a, b) => {
          let aVal = a.toString().split(',');
          let bVal = b.toString().split(',');
          return bVal[0] - aVal[0] || bVal[1] - aVal[1];
      });

      if (rmList.length > 0) {
          rmList.forEach(c => {
              let val = c.toString().split(',');
              if (val.length === 1) {
                  this.menuList.splice(c, 1);
              } else {
                  this.menuList[val[0]].items.splice(val[1], 1);
              }
          });
      }
    },
    showUserInfo(){
      this.userInfoVisible = true;
    }, 
    /** 计算菜单项的跳转路由路径，为空或无法匹配路由时返回空字符串 */
    getMenuItemRoute(item) {
      if (!item) return '';
      let route = '';
      if (item.type == 10) {
        route = '/index/report/' + item.id;
      } else if (item.type == 20) {
        route = item.path || '';
      } else {
        if (item.code) {
          route = '/index/' + item.code;
        } else if (item.path) {
          route = item.path;
        } else if (item.id) {
          route = '/index/app/' + item.id;
        }
      }
      return route;
    },
    /** 判断菜单项路由是否为空（用于红色标记） */
    isEmptyRoute(item) {
      const route = this.getMenuItemRoute(item);
      if (!route) return true;
      // 检查路由是否能在 router 中解析到有效组件（而非通配符 404）
      const resolved = this.$router.resolve(route);
      if (!resolved || !resolved.route) return true;
      // 如果匹配到了通配符路由（404），也视为空路由
      if (resolved.route.path === '*' || resolved.route.name === 'not-found') return true;
      // 如果是 /index/:id? 的子路由，但没有匹配到任何 children，matched 里只有父路由
      // 此时 router-view 不会渲染任何子组件
      if (route.startsWith('/index/') && resolved.route.matched && resolved.route.matched.length < 2) return true;
      return false;
    },
    jumpApp(data, menuIndex, itemIndex) {
      // 不用 isNavigating 拦截 — 允许新点击覆盖旧导航（解决快速连续点击竞态）
      this.pendingJumpAppId = data.id;
      this.currExtData = undefined;
      this.routeLoading = true;
      this.isNavigating = true;
      
      // 生成本次导航的唯一序列号，旧导航的回调发现序列号不匹配就不清理状态
      const navId = ++this.navSeqId;
      
      // 设置菜单激活状态 — 统一用菜单项的 id（与模板 :index 一致）
      if (data.id) {
        this.menuActiveIndex = data.id;
      } else if (menuIndex !== null && menuIndex !== undefined && itemIndex !== null && itemIndex !== undefined) {
        this.menuActiveIndex = `${menuIndex}-${itemIndex}`;
      }
      if (menuIndex !== null && menuIndex !== undefined) {
        const menu = this.menuList[menuIndex];
        if (menu) {
          this.defaultOpeneds = [menu.id];
        }
      }
      
      // 导航完成回调 — 只有最新的 navId 才清理状态
      const onNav = (success) => {
        if (this.navSeqId !== navId) return; // 已被更新的导航覆盖
        this.routeLoading = false;
        this.isNavigating = false;
        this.pendingJumpAppId = null;
        if (success) {
          // 导航成功后确保 menuActiveIndex 与实际路由一致
          this.$nextTick(() => this.updateMenuState());
        }
      };
      
      if (data.type == 10) {
        const path = '/index/report/' + data.id;
        if (this.$route.path !== path) {
          this.$router.push(path).then(() => onNav(true)).catch(() => onNav(false));
        } else {
          onNav(true);
        }
        if (menuIndex !== null && menuIndex !== undefined) {
          this.menuPathMap[path] = { menuIndex, itemIndex, menuId: this.menuList[menuIndex]?.id };
        }
      } else if (data.type == 20) { 
        if (this.$route.path !== data.path) {
          this.$router.push(data.path).then(() => onNav(true)).catch(() => onNav(false));
        } else {
          onNav(true);
        }
      } else {
        let path = '/index/app/' + data.id;
        if (data.code) {
          path = '/index/' + data.code;
        } else if (data.path) {
          path = data.path;
        }
        if (this.$route.path !== path) {
          this.$router.push(path).then(() => onNav(true)).catch(() => onNav(false));
        } else {
          onNav(true);
        }
        if (menuIndex !== null && menuIndex !== undefined) {
          this.menuPathMap[path] = { menuIndex, itemIndex, menuId: this.menuList[menuIndex]?.id };
        }
      }
    }, 
    switchMode(){
      this.$router.push('/home');
    }, 
    handleOpen() {},
    handleClose() {},
    switchCollapse(){
      this.isCollapse = !this.isCollapse;
    },
    logout(){
      clearCache();
      this.$router.push('/login');
    },
    jumpRouter(router){
      this.$router.push(router);
    },
    /** 生成UUID */
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    /** 格式化日期时间 */
    formatDateTime(val) {
      if (!val) return '-';
      return new Date(val).toLocaleString('zh-CN');
    },
    /** 获取完整URL（兼容COS和相对路径） */
    getFullUrl(url) {
      if (!url) return '';
      if (url.startsWith('http')) return url;
      const baseUrl = process.env.NODE_ENV === 'production' ? window.globalConfig.rootUrl : process.env.VUE_APP_BASE_URL;
      return baseUrl + url;
    },
    /** 显示工单列表弹框 */
    showWorkOrderList() {
      this.workOrderListVisible = true;
      this.workOrderListPage = 1;
      this.workOrderListFilter = '';
      this.loadWorkOrderList();
    },
    /** 加载工单列表 */
    async loadWorkOrderList() {
      this.workOrderListLoading = true;
      try {
        const params = { SkipCount: (this.workOrderListPage - 1) * 10, MaxResultCount: 10 };
        if (this.workOrderListFilter !== '') params.Status = parseInt(this.workOrderListFilter);
        const res = await authrequest({ url: '/api/app/work-order/my-list', method: 'get', params });
        this.workOrderListData = res.items || [];
        this.workOrderListTotal = res.totalCount || 0;
      } catch (err) {
        this.$message.error('加载工单列表失败');
      } finally {
        this.workOrderListLoading = false;
      }
    },
    /** 查看工单详情 */
    async viewWorkOrderDetail(row) {
      this.workOrderDetailVisible = true;
      this.workOrderDetailLoading = true;
      try {
        this.workOrderDetail = await authrequest({ url: `/api/app/work-order/${row.id}`, method: 'get' });
      } catch (err) {
        this.$message.error('加载工单详情失败');
      } finally {
        this.workOrderDetailLoading = false;
      }
    },
    /** 显示工单表单弹框 */
    showWorkOrderForm() {
      this.workOrderId = this.generateUUID();
      this.workOrderFormVisible = true;
    },
    /** 重置工单表单 */
    resetWorkOrderForm() {
      this.workOrderForm = { title: '', tag: 0, content: '', remark: '', imageUrls: [], imageFileList: [] };
      this.workOrderId = '';
      this.screenshotUploading = false;
      if (this.$refs.workOrderForm) {
        this.$refs.workOrderForm.resetFields();
      }
    },
    /** 截图上传前校验 */
    beforeScreenshotUpload(file) {
      const isImage = /\.(jpe?g|png|gif|webp)$/i.test(file.name);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) { this.$message.error('仅支持 jpg/png/gif/webp 格式的图片'); return false; }
      if (!isLt5M) { this.$message.error('图片大小不能超过5MB'); return false; }
      return true;
    },
    /** 多图上传 */
    async handleImageUpload({ file }) {
      this.screenshotUploading = true;
      try {
        const formData = new FormData();
        formData.append('file', file);
        const url = await authrequest({ url: `/api/app/upload/image?workOrderId=${this.workOrderId}`, method: 'post', data: formData });
        this.workOrderForm.imageUrls.push(url);
        this.workOrderForm.imageFileList.push({ name: file.name, url: url.startsWith('http') ? url : (process.env.NODE_ENV === 'production' ? window.globalConfig.rootUrl : process.env.VUE_APP_BASE_URL) + url });
      } catch (err) {
        this.$message.error('截图上传失败: ' + (err.message || '未知错误'));
      } finally {
        this.screenshotUploading = false;
      }
    },
    /** 删除已上传截图 */
    handleImageRemove(file) {
      const idx = this.workOrderForm.imageFileList.findIndex(f => f.url === file.url);
      if (idx > -1) {
        this.workOrderForm.imageFileList.splice(idx, 1);
        this.workOrderForm.imageUrls.splice(idx, 1);
      }
    },
    /** 提交工单 */
    async submitWorkOrder() {
      try { await this.$refs.workOrderForm.validate(); } catch { return; }
      this.workOrderSubmitting = true;
      try {
        await authrequest({
          url: '/api/app/work-order',
          method: 'post',
          data: {
            id: this.workOrderId || undefined,
            title: this.workOrderForm.title,
            tag: this.workOrderForm.tag,
            content: this.workOrderForm.content,
            remark: this.workOrderForm.remark,
            imageUrls: this.workOrderForm.imageUrls.length ? this.workOrderForm.imageUrls : undefined
          }
        });
        this.$message.success('工单提交成功');
        this.workOrderFormVisible = false;
        if (this.workOrderListVisible) this.loadWorkOrderList();
      } catch (err) {
        this.$message.error('工单提交失败: ' + (err.message || '未知错误'));
      } finally {
        this.workOrderSubmitting = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
}
.el-menu-vertical-demo {
  height: 100%;
}
.content {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.title {
  width: 100%;
  height: 60px;
  padding: 0;
  margin-bottom: 1px;
}
.menu-line {
  border-left: 1px solid #ccc; 
  height: 40%; 
  width: 2px; 
  position: absolute; 
  left: 0; 
  top: 20px;
}
.switchmode {
  position: absolute;
  right: 5px;
}
.user {
  position: absolute;
  right: 5px;
}
.body {
  max-height: calc(100vh - 45px);
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow-y: hidden;

  .menu {
    height: 100%;
    transition: all 0.8s;
    background: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative; 

    .skeleton {
      width: 224px;
      height: calc(100% - 20px);
      margin: 10px 8px 10px 8px;
    }
  }
  .menu-search {
    height: 40px; 
    position: fixed;
    top: 8px;
    left: 280px;
    z-index: 99939;
    width: 240px;
  }

  .menu-null {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #a6a0a0;
    margin-left: 39px;
  }

  .main {
    flex: 1;
    min-width: 0;
    height: calc(100vh - 85px);
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    
    .skeleton {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      padding: 20px;
      box-sizing: border-box;
    }
  }
  .main::-webkit-scrollbar {
      height: 12px; /* 滚动条高度 */
      background-color: #F2F6FC; /* 滚动条背景颜色 */
  }
  /* 滚动条滑块样式 */
  .main::-webkit-scrollbar-thumb {
      background-color: #909399; /* 滚动条滑块颜色 */
      border-radius: 6px; /* 滑块圆角 */
  }
}

.ext {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: auto;
}

.inst-name {
  color: #409EFF;font-size: 14px; cursor: pointer;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #F2F6FC;
  border-radius: 2px;
}
::-webkit-scrollbar:hover {
  width: 10px;
  height: 10px;
  background-color: #DCDFE6;
  border-radius: 2px;
}
</style>
